module.exports = __webpack_public_path__ + "media/images/emblems/Niederbipp-coat_of_arms-c732c388e5fc2ec27ff81e4c6d325556.svg";